import React from "react";
import { DashboardPageLayout } from "../../../components/layout/DashboardPageLayout";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "../../../components/ui/card";
import type { AdminOverviewStats } from "../types";

type AdminOverviewPageProps = {
  overview: AdminOverviewStats;
};

export const AdminOverviewPage: React.FC<AdminOverviewPageProps> = ({
  overview,
}) => (
  <DashboardPageLayout
    title="Admin Overview"
    subtitle="Platform metrics and recent activity"
  >
    <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-4">
      <Card>
        <CardHeader className="pb-2">
          <CardTitle className="text-sm font-medium text-muted-foreground">
            Users
          </CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-2xl font-bold">{overview.userCount}</p>
        </CardContent>
      </Card>

      <Card>
        <CardHeader className="pb-2">
          <CardTitle className="text-sm font-medium text-muted-foreground">
            Organizations
          </CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-2xl font-bold">{overview.organizationCount}</p>
        </CardContent>
      </Card>

      <Card>
        <CardHeader className="pb-2">
          <CardTitle className="text-sm font-medium text-muted-foreground">
            Websites
          </CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-2xl font-bold">{overview.businessCount}</p>
        </CardContent>
      </Card>

      <Card>
        <CardHeader className="pb-2">
          <CardTitle className="text-sm font-medium text-muted-foreground">
            Quotes
          </CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-2xl font-bold">{overview.quoteCount}</p>
        </CardContent>
      </Card>

      <Card>
        <CardHeader className="pb-2">
          <CardTitle className="text-sm font-medium text-muted-foreground">
            Signups (7 days)
          </CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-2xl font-bold">{overview.recentSignupCount}</p>
        </CardContent>
      </Card>
    </div>

    <Card className="mt-6">
      <CardHeader>
        <CardTitle>Billing Distribution</CardTitle>
        <CardDescription className="sr-only">
          Count of organizations by website product billing status
        </CardDescription>
      </CardHeader>
      <CardContent>
        <dl className="grid gap-2 sm:grid-cols-2 md:grid-cols-3">
          {Object.entries(overview.billingDistribution).map(
            ([status, count]) => (
              <div
                key={status}
                className="flex justify-between rounded-lg border p-3"
              >
                <dt className="font-medium capitalize">{status}</dt>
                <dd>{count}</dd>
              </div>
            ),
          )}
        </dl>
      </CardContent>
    </Card>
  </DashboardPageLayout>
);
